var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2012_13515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2012_13515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47332 17.5007C3.18166 17.5701 2.92818 17.4972 2.71291 17.2819C2.49763 17.0666 2.42471 16.8132 2.49416 16.5215L3.32749 12.5423L7.45249 16.6673L3.47332 17.5007ZM7.45249 16.6673L3.32749 12.5423L12.8692 3.00065C13.1886 2.68121 13.5844 2.52148 14.0567 2.52148C14.5289 2.52148 14.9247 2.68121 15.2442 3.00065L16.9942 4.75065C17.3136 5.0701 17.4733 5.46593 17.4733 5.93815C17.4733 6.41037 17.3136 6.80621 16.9942 7.12565L7.45249 16.6673ZM14.0567 4.16732L5.43166 12.7923L7.20249 14.5631L15.8275 5.93815L14.0567 4.16732Z",
    fill: "#0065FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.8aef7627e4702bbbc8150280ecf61ce7.svg";
export { ForwardRef as ReactComponent };